//@ts-nocheck
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { ActionCode, TLCode } from '../../common/enums';
import { Instance } from 'mobx-state-tree';
import { toJS } from 'mobx';
import VerticalForm from '../common/form/VerticalForm';
import { CheckboxInputFormField, TextInputFormField, SwitchInputFormField } from '../common/form';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { Form } from 'react-final-form';
import LanguageFormField from '../common/form/LanguageFormField';
import DayOfWeekFormField from '../common/form/DayOfWeekFormField';
import GroupFormField from '../common/form/GroupFormField';
import AnchorFormField from '../common/form/AnchorFormField';
import PharmacyStatusFormField from '../common/form/PharmacyStatusFormField';
import MainMunicipalityFormField from '../common/form/MainMunicipalityFormField';
import { Button, ButtonGroup, Intent, InputGroup, Switch, Radio, RadioGroup, Tooltip, Position } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import SimpleTextFormContent from '../common/form/SimpleTextFormGroup';
import { Pharmacy } from '../../store/models/Pharmacy';
import styled from '@emotion/styled';
import UserFormField from '../common/form/UserFormField';
import { User } from '../../store/models/User';
import { Group } from '../../store/models/Group';
import { Municipality } from '../../store/models/Municipality';
import LeaveRouteDirtyWrapper from '../common/LeaveRouteDirtyWrapper';
import { CheckBox } from 'devextreme-react';

import {
  AuthenticationStore,
  PharmacyDetailedStore,
  DutyOffRequestStore,
  GroupStore,
  SecretariatStore,
  PharmacyStatusStore,
  PharmacyStore,
  ApplicationStore,
  UserStore,
} from '../../store';
import SecretariatFormField from '../common/form/SecretariatFormField';
import { Secretariat } from '../../store/models';
import { Page } from '../../common/enums/Page';
import { RefreshGeoDataDialog } from '../common/dialog/RefreshGeoDataDialog';
import { SharedDutiesPharmaciesDialog } from '../common/dialog/SharedDutiesPharmaciesDialog';
import CheckboxInput from '../common/input/basicInputs/CheckboxInput';
import { head } from 'lodash';
import { PHARMACY_STATUS_AC } from '../../common/constants/pharmacyStatusConstants';

interface PharmacyFormProps extends WithTranslateProps {
  pharmacy?: Instance<typeof Pharmacy>;
  userList?: Array<Instance<typeof User>>;
  groupList?: Array<Instance<typeof Group>>;
  anchorList?: Array<Instance<typeof Anchor>>;
  municipalityList?: Array<Instance<typeof Municipality>>;
  secretariatList?: Array<Instance<typeof Secretariat>>;
  save: (data: any) => void;
  userRoles: string[];
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  PharmacyDetailedStore?: Instance<typeof PharmacyDetailedStore>;
  DutyOffRequestStore?: Instance<typeof DutyOffRequestStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
  PharmacyStatusStore?: Instance<typeof PharmacyStatusStore>;
  PharmacyStore?: Instance<typeof PharmacyStore>;
  ApplicationStore?: Instance<typeof ApplicationStore>;
  UserStore?: Instance<typeof UserStore>;
}

interface PharmacyFormState {
  loading: boolean;
  user: any;
  level: any;
  isGroupMandatory: boolean;
  checkStartYear: string;
  selectedUserId: number | undefined;
  refreshGeoDataDialogDone: boolean;
  refreshGeoDataDialoginProgress: boolean;
  refreshGeoDataDialoginError: boolean;
  isSharedDutiesDialogOpen: boolean;
}

@inject('AuthenticationStore')
@inject('PharmacyDetailedStore')
@inject('PharmacyStore')
@inject('DutyOffRequestStore')
@inject('SecretariatStore')
@inject('PharmacyStatusStore')
@inject('ApplicationStore')
@inject('UserStore')
@observer
class PharmacyForm extends React.Component<PharmacyFormProps, PharmacyFormState> {
  constructor(props: PharmacyFormProps) {
    super(props);
    const pharmacyStatusIdActive = this.props.PharmacyStatusStore!.dataList.find((status) => status.code === PHARMACY_STATUS_AC)!.statusId;
    this.state = {
      loading: false,
      user: this.props.userList!.filter((u) => u.userId == this.props.pharmacy!['userId'])[0],
      level: this.props.pharmacy!['level'],
      isGroupMandatory: this.props.pharmacy!['level'] === 3 && this.props.pharmacy!['statusId'] === pharmacyStatusIdActive,
      checkStartYear: new Date().getFullYear().toString(),
      selectedUserId: this.props.pharmacy!['userId'],
      refreshGeoDataDialogDone: false,
      refreshGeoDataDialoginProgress: false,
      refreshGeoDataDialoginError: false,
      isSharedDutiesDialogOpen: false,
    };
  }

  _isMounted = false;

  async componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  canEditPharmacy = () => {
    return (
      this.props.AuthenticationStore!.isSuperAdmin ||
      (this.props.pharmacy !== undefined &&
        this.props.AuthenticationStore!.isSecretariat &&
        this.props.AuthenticationStore!.secretariatId === this.props.pharmacy!.secretariatId)
    );
  };

  refreshGeoData = async () => {
    this.setState({ refreshGeoDataDialoginProgress: true });
    const result = ((await this.props.PharmacyDetailedStore!.updatePharmacyGeoData(
      this.props.pharmacy!.pharmacyId,
    )) as unknown) as boolean;
    if (result) {
      this.setState({ refreshGeoDataDialogDone: true, refreshGeoDataDialoginProgress: false });
    } else {
      this.setState({ refreshGeoDataDialoginError: true, refreshGeoDataDialoginProgress: false });
    }
  };

  refreshWGS64 = async () => {
    const res = await this.props.PharmacyDetailedStore!.refreshWGS64(this.props.pharmacy!.pharmacyId);
  }

  onRefreshGeoDataDialogClosed = () => {
    this.setState({
      refreshGeoDataDialogDone: false,
      refreshGeoDataDialoginProgress: false,
      refreshGeoDataDialoginError: false,
    });
  };

  onCheckStartYearChanged = (value) => {
    this.setState({ checkStartYear: value });
  };

  checkDutyOffRequests = async () => {
    this._isMounted && this.setState({ loading: true });
    await this.props.DutyOffRequestStore!.checkPharmacyDutyOffRequests(
      this.state.checkStartYear,
      this.props.pharmacy!.apbNumber.toString(),
    );
    this._isMounted && this.setState({ loading: false });
  };

  onLevelChange = (value) => {
    this.setState({ level: value });
  };

  getUserStatus = () => {
    const user = this.props.UserStore!.getById(this.state.selectedUserId);
    return user ? user.isActive : undefined;
  };

  private getSecretariatId = () => {
    if (this.props.AuthenticationStore!.isSuperAdmin)
      return this.props.SecretariatStore!.selectedSecretariatId === 0
        ? undefined
        : this.props.SecretariatStore!.selectedSecretariatId;
    if (this.props.AuthenticationStore!.isSecretariat) return this.props.AuthenticationStore!.secretariatId;
    return undefined;
  };

  private impersonate = (ev) => {
    const { AuthenticationStore, userList, pharmacy } = this.props;
    const user = userList!.filter((u) => u.userId == pharmacy!['userId'])[0];
    AuthenticationStore!.impersonate(user['userName']);
  };

  private openSharedDutiesPharmacies = () => {
    this.setState({ isSharedDutiesDialogOpen: true });
  };

  private recalculateDefaultExchangeFlags  = () => {
    this.props.PharmacyStore!.recalculateDefaultExchangeFlags(this.props.pharmacy!.pharmacyId);
  };

  private reapplyDefaultExchangeFlags  = () => {
    this.props.PharmacyStore!.reapplyDefaultExchangeFlags(this.props.pharmacy!.pharmacyId);
  };

  private recalculateDefaultPairingFlags  = () => {
    this.props.PharmacyStore!.recalculateDefaultPairingFlags(this.props.pharmacy!.pharmacyId);
  };

  private reapplyDefaultPairingFlags  = () => {
    this.props.PharmacyStore!.reapplyDefaultPairingFlags(this.props.pharmacy!.pharmacyId);
  };

  public render() {
    const {
      pharmacy,
      translate,
      save,
      userList,
      userRoles,
      groupList,
      anchorList,
      municipalityList,
      secretariatList,
    } = this.props;
    const canEdit = userRoles.includes(ActionCode.ADMIN_CODE) || userRoles.includes(ActionCode.SECRETARY_USER_CODE);
    const isGroupMandatory = this.state.isGroupMandatory;

    const { refreshGeoDataDialogDone, refreshGeoDataDialoginProgress, refreshGeoDataDialoginError } = this.state;

    const { isSharedDutiesDialogOpen } = this.state;

    const secretariatId = this.getSecretariatId();

    return (
      <>
        <RefreshGeoDataDialog
          translate={this.props.translate}
          done={refreshGeoDataDialogDone}
          inError={refreshGeoDataDialoginError}
          inProgress={refreshGeoDataDialoginProgress}
          onClose={this.onRefreshGeoDataDialogClosed}
        />
        <SharedDutiesPharmaciesDialog
          isOpen={isSharedDutiesDialogOpen}
          close={() => this.setState({ isSharedDutiesDialogOpen: false })}
          pharmacies={this.props.PharmacyStore!.dataList}
          pharmacyToLink={pharmacy!}
          translate={translate}
          linkPharmacies={this.props.PharmacyStore!.linkPharmaciesWithSharedDutiesGroup}
          unlinkPharmacies={this.props.PharmacyStore!.unlinkPharmaciesWithSharedDutiesGroup}
        />
        <Form
          initialValues={toJS(pharmacy) || {}}
          onSubmit={save}
          render={({ handleSubmit, form, hasValidationErrors, dirty }) => (
            <form onSubmit={handleSubmit}>
              <LeaveRouteDirtyWrapper blockChange={dirty} />
              <Container>
                <VerticalForm labelWidth={105}>
                  <DivLine>
                    <DivColumn style={{ width: 200 }}>
                      <TextInputFormField
                        name="apbNumber"
                        required={true}
                        label={TLCode.PHARMACY_ApbNr}
                        inline={true}
                        fill={true}
                        validate={[]}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                    </DivColumn>
                    <DivColumn style={{ width: 160 }}>
                      <TextInputFormField
                        name="level"
                        label={TLCode.PHARMACY_Level}
                        inline={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                    </DivColumn>
                    <DivColumn style={{ width: 'auto', textAlign: 'end' }}>
                      <PharmacyStatusFormField
                        label={TLCode.PHARMACY_Status}
                        name="statusId"
                        disabled={!canEdit || !this.canEditPharmacy()}
                        isClearable={false}
                      />
                    </DivColumn>
                  </DivLine>
                  <DivLine>
                    <DivColumn style={{ width: 250 }}>
                      <SecretariatFormField
                        label={TLCode.SECRETARIAT}
                        name="secretariatId"
                        secretariatList={secretariatList}
                        disabled={!this.props.AuthenticationStore!.isSuperAdmin}
                        isClearable={this.props.AuthenticationStore!.isSuperAdmin}
                      />
                    </DivColumn>
                    <DivColumn style={{ width: 500 }}>
                      <GroupFormField
                        label={TLCode.PHARMACIES_Group}
                        name="groupId"
                        groupList={
                          groupList !== undefined
                            ? groupList.filter((g) => secretariatId === undefined || g.secretariatId === secretariatId)
                            : undefined
                        }
                        disabled={!canEdit || !this.canEditPharmacy()}
                        isClearable={canEdit && this.canEditPharmacy()}
                      />
                    </DivColumn>
                    <DivColumn style={{ width: 'auto', textAlign: 'end' }}>
                      <AnchorFormField
                        label={TLCode.PHARMACIES_Anchor}
                        name="anchorId"
                        anchorList={
                          anchorList !== undefined
                            ? anchorList.filter((a) => pharmacy.groupId === undefined || a.groupId === pharmacy.groupId)
                            : undefined
                        }
                        disabled={!canEdit || !this.canEditPharmacy()}
                        isClearable={canEdit && this.canEditPharmacy()}
                      />
                    </DivColumn>
                  </DivLine>
                  <DivLine>
                    <DivColumn>
                      <TextInputFormField
                        name="name"
                        required={true}
                        label={TLCode.PHARMACIES_PharmacyName}
                        inline={true}
                        fill={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                    </DivColumn>
                    <div style={{ minWidth: 500, display: 'flex', flexDirection: 'row', justifyContent: 'left' }}>
                      <UserFormField
                        name="userId"
                        userList={userList}
                        disabled={!canEdit || !this.canEditPharmacy()}
                        onUserSelected={(id) => this.setState({ selectedUserId: id })}
                      />
                      {(this.props.AuthenticationStore!.isSuperAdmin || this.props.AuthenticationStore!.isAdmin) &&
                        this.state.selectedUserId !== undefined && (
                          <>
                            <Tooltip
                              content={translate(TLCode.PHARMACY_Goto_User)}
                              position={Position.BOTTOM}
                              hoverOpenDelay={500}
                            >
                              <Button
                                icon="user"
                                onClick={() =>
                                  this.props.ApplicationStore!.navigate(`${Page.UserPage}/${this.state.selectedUserId}`)
                                }
                              />
                            </Tooltip>
                            <CheckBox
                              style={{ marginLeft: '25px', height: '28px' }}
                              value={this.getUserStatus()}
                              text={translate(TLCode.USER_Is_Active)}
                              rtlEnabled={true}
                              disabled={true}
                              iconSize="25px"
                            />
                          </>
                        )}
                    </div>
                    <DivColumn style={{ width: 300 }}>
                      {this.state.user && (
                        <a href={'mailto:' + this.state.user.email + '?subject=Pharmagarde'}>{this.state.user.email}</a>
                      )}
                    </DivColumn>
                    {this.props.AuthenticationStore!.isSuperAdmin && (
                      <DivColumn>
                        <DivLine>
                          <Button
                            text={translate(TLCode.USER_Impersonate)}
                            icon={IconNames.PEOPLE}
                            intent={Intent.DANGER}
                            onClick={this.impersonate}
                          />
                        </DivLine>
                      </DivColumn>
                    )}{' '}
                  </DivLine>
                  <DivLine>
                    <DivColumn style={{ minWidth: 250, width: 250 }}>
                      <TextInputFormField
                        name="phone"
                        label={TLCode.PHARMACY_Phone}
                        inline={true}
                        fill={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                    </DivColumn>
                    <DivColumn style={{ minWidth: 250, width: 250 }}>
                      <TextInputFormField
                        name="mobile"
                        label={TLCode.PHARMACY_Mobile || !this.canEditPharmacy()}
                        inline={true}
                        fill={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                    </DivColumn>
                    <DivColumn style={{ width: 160 }}>
                      <SimpleTextFormContent label={TLCode.PHARMACY_ReceivesSms} small={false}>
                        <CheckboxInputFormField
                          name="receivesSms"
                          inline={true}
                          disabled={!canEdit || !this.canEditPharmacy()}
                        />
                      </SimpleTextFormContent>
                    </DivColumn>
                    <DivColumn>
                      <LanguageFormField
                        name="language"
                        required={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                        isClearable={canEdit && this.canEditPharmacy()}
                      />
                    </DivColumn>
                  </DivLine>
                  <DivLine>
                    <DivColumn style={{ width: '50%' }}>
                      <TextInputFormField
                        name="address"
                        label={TLCode.PHARMACIES_Address}
                        inline={true}
                        fill={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                    </DivColumn>
                  </DivLine>
                  <DivLine>
                    <DivColumn style={{ width: '40%' }}>
                      <TextInputFormField
                        name="city"
                        label={TLCode.PHARMACIES_City}
                        inline={true}
                        fill={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                    </DivColumn>
                    <DivColumn style={{ width: '20%' }}>
                      <TextInputFormField
                        name="zipCode"
                        label={TLCode.PHARMACIES_ZipCode}
                        inline={true}
                        fill={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                    </DivColumn>
                    <DivColumn style={{ width: '40%' }}>
                      <MainMunicipalityFormField
                        label={TLCode.PHARMACIES_Municipality}
                        municipalityList={municipalityList}
                        disabled={true}
                        isClearable={false}
                      />
                    </DivColumn>
                  </DivLine>
                  <DivLine>
                    <DivColumn50>
                      <TextInputFormField
                        name="anchor"
                        label={TLCode.PHARMACY_Anchor}
                        inline={true}
                        fill={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                    </DivColumn50>
                  </DivLine>
                  {(canEdit || this.canEditPharmacy()) && (
                    <DivLine>
                      <DivColumn>
                        <DayOfWeekFormField
                          label={TLCode.PHARMACY_PrefDayOff}
                          name="prefDutyDayOff"
                          required={false}
                          disabled={!canEdit || !this.canEditPharmacy()}
                          labelSelectAnElement={''}
                        />
                      </DivColumn>
                      <DivColumn50>
                        <SecretariatFormField
                          label={TLCode.SECRETARIAT}
                          name="secretariatId"
                          secretariatList={secretariatList}
                          disabled={!this.props.AuthenticationStore!.isSuperAdmin}
                        />
                      </DivColumn50>
                      <DivColumn>
                        <SimpleTextFormContent label={TLCode.PHARMACY_IsContributing} small={false}>
                          <CheckboxInputFormField
                            name="isContributing"
                            inline={true}
                            disabled={!canEdit || !this.canEditPharmacy()}
                          />
                        </SimpleTextFormContent>
                      </DivColumn>
                    </DivLine>
                  )}
                  <DivLine />
                  <DivLine>
                    <DivColumn>
                      <TextInputFormField
                        name="x"
                        label={TLCode.PHARMACY_X_Lambert2008}
                        inline={true}
                        fill={true}
                        disabled={!canEdit}
                      />
                    </DivColumn>
                    <DivColumn>
                      <TextInputFormField
                        name="y"
                        label={TLCode.PHARMACY_Y_Lambert2008}
                        inline={true}
                        fill={true}
                        disabled={!canEdit}
                      />
                    </DivColumn>
                    <DivColumn />
                  </DivLine>
                  <DivLine>
                    <DivColumn>
                      <TextInputFormField
                        name="latitude"
                        label={TLCode.PHARMACY_Latitude}
                        inline={true}
                        fill={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                      <TextInputFormField
                        name="minDistance"
                        label={TLCode.PHARMACY_DayMinDistance}
                        inline={true}
                        fill={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                      <TextInputFormField
                        name="minDistance2"
                        label={TLCode.PHARMACY_NightMinDistance}
                        inline={true}
                        fill={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                    </DivColumn>
                    <DivColumn>
                      <TextInputFormField
                        name="longitude"
                        label={TLCode.PHARMACY_Longitude}
                        inline={true}
                        fill={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                      <TextInputFormField
                        name="maxDistance"
                        label={TLCode.PHARMACY_DayMaxDistance}
                        inline={true}
                        fill={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                      <TextInputFormField
                        name="maxDistance2"
                        label={TLCode.PHARMACY_NightMaxDistance}
                        inline={true}
                        fill={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                    </DivColumn>
                    <DivColumn>
                      <Button
                        text={translate(TLCode.PHARMACY_RefreshGeoData)}
                        icon={IconNames.REFRESH}
                        intent={Intent.DANGER}
                        onClick={this.refreshWGS64}
                        hidden={!canEdit || !this.canEditPharmacy()}
                      />
                      <TextInputFormField
                        name="density"
                        label={TLCode.PHARMACY_Density}
                        inline={true}
                        fill={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                      <Button
                        text={translate(TLCode.PHARMACY_RefreshGeoData)}
                        icon={IconNames.REFRESH}
                        intent={Intent.DANGER}
                        onClick={this.refreshGeoData}
                        hidden={!canEdit || !this.canEditPharmacy()}
                      />
                    </DivColumn>
                  </DivLine>
                  <DivLine>
                    {this.canEditPharmacy() && (
                      <DivColumn>
                        <DivLine>
                          <InputGroup
                            placeholder="year to start checking"
                            value={this.state.checkStartYear}
                            onChange={(e) => this.onCheckStartYearChanged(e.target.value)}
                          />
                          <Button
                            intent={Intent.PRIMARY}
                            onClick={this.checkDutyOffRequests}
                            text={translate(TLCode.PHARMACY_CheckDutyOffRequests)}
                          />
                        </DivLine>
                      </DivColumn>
                    )}
                  </DivLine>
                  <DivLine>
                    {this.canEditPharmacy() && (
                      <Button
                        intent={Intent.PRIMARY}
                        onClick={this.openSharedDutiesPharmacies}
                        text={translate(TLCode.PHARMACY_SharedDutiesGroup_Btn)}
                      />
                    )}
                  </DivLine>
                  <DivLine>
                    {this.canEditPharmacy() && (
                      <>
                      <DivColumn>
                      <div style={{ display:'flex', paddingTop:'5px'}}>
                      <b>{translate(TLCode.PHARMACY_RecalculateExchangeAllowed_Lbl)}</b>&nbsp;
                      {/* <ButtonGroup> */}
                          <Tooltip
                              content={translate(TLCode.PHARMACY_RecalculateDefaultExchangeFlags_ToolTip)}
                              position={Position.BOTTOM}
                              hoverOpenDelay={500}
                          >
                            <Button
                              intent={Intent.PRIMARY}
                              onClick={this.recalculateDefaultExchangeFlags}
                              text={translate(TLCode.PHARMACY_RecalculateDefaultExchangeFlags_Btn)}
                            />
                          </Tooltip>
                          &nbsp;&nbsp;
                          <Tooltip
                              content={translate(TLCode.PHARMACY_ReapplyDefaultExchangeFlags_ToolTip)}
                              position={Position.BOTTOM}
                              hoverOpenDelay={500}
                          >
                          <Button
                            intent={Intent.DANGER}
                            onClick={this.reapplyDefaultExchangeFlags}
                            text={translate(TLCode.PHARMACY_ReapplyDefaultExchangeFlags_Btn)}
                          />
                        </Tooltip>
                      {/* </ButtonGroup> */}
                      </div>
                      </DivColumn>
                      <DivColumn>
                      <div style={{ display:'flex', paddingTop:'5px'}}>
                      <b>{translate(TLCode.PHARMACY_RecalculatePairingAllowed_Lbl)}</b>&nbsp;
                      {/* <ButtonGroup> */}
                          <Tooltip
                              content={translate(TLCode.PHARMACY_RecalculateDefaultPairingFlags_ToolTip)}
                              position={Position.BOTTOM}
                              hoverOpenDelay={500}
                          >
                            <Button
                              intent={Intent.PRIMARY}
                              onClick={this.recalculateDefaultPairingFlags}
                              text={translate(TLCode.PHARMACY_RecalculateDefaultPairingFlags_Btn)}
                            />
                          </Tooltip>
                          &nbsp;&nbsp;
                          <Tooltip
                              content={translate(TLCode.PHARMACY_ReapplyDefaultPairingFlags_ToolTip)}
                              position={Position.BOTTOM}
                              hoverOpenDelay={500}
                          >
                          <Button
                            intent={Intent.DANGER}
                            onClick={this.reapplyDefaultPairingFlags}
                            text={translate(TLCode.PHARMACY_ReapplyDefaultExchangeFlags_Btn)}
                          />
                        </Tooltip>
                      {/* </ButtonGroup> */}
                      </div>
                      </DivColumn>
                      </>
                    )}
                  </DivLine>
                  <DivLine />
                </VerticalForm>
                {canEdit && (
                  <>
                    <br />
                    <div
                      style={{
                        position: 'fixed',
                        bottom: '70px', // distance depuis le bord inférieur de l’écran
                        right: '100px', // distance depuis le bord droit
                        zIndex: 1000, // s’assurer qu’il est au-dessus du reste
                      }}
                    >
                      <ButtonsContainer>
                        <Button
                          text={translate(TLCode.GENERAL_Cancel)}
                          icon={IconNames.ERASER}
                          intent={Intent.PRIMARY}
                          onClick={() => form.reset()}
                          disabled={!dirty || !this.canEditPharmacy()}
                          style={{
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                          }}
                        />
                        <Button
                          type={'submit'}
                          text={translate(TLCode.GENERAL_Save)}
                          icon={IconNames.FLOPPY_DISK}
                          intent={Intent.PRIMARY}
                          disabled={hasValidationErrors || !dirty || !this.canEditPharmacy()}
                          style={{
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                          }}
                        />
                      </ButtonsContainer>
                    </div>
                  </>
                )}
              </Container>
            </form>
          )}
        />
      </>
    );
  }
}

export default withTranslate(PharmacyForm);

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
`;

const DivColumn50 = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  width: 50%;
`;

const DivColumn25 = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  width: 25%;
`;

const Container = styled.div({
  display: 'flex',
  width: '85%',
  flexDirection: 'column',
});

const ButtonsContainer = styled.div({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'flex-end',
  '& button': {
    marginLeft: 5,
  },
});

const ContrainerCheckbox = styled.div({
  display: 'flex',
  flexDirection: 'column',
  '& .bp3-form-group': {
    marginBottom: '0px',
  },
});
